export const isImageFromContentType = (contentType?: string) =>
  !!contentType?.match(/^image\/(jpeg|jpg|gid|png)$/);
